let activeClickHandler: ((event: MouseEvent) => void) | null = null;

export const handleHighlightNext = (
  element: Element | null,
  opts: { driver: { moveNext: () => void } },
) => {
  if (!element) return;

  activeClickHandler = () => {
    opts.driver.moveNext();
  };

  element.addEventListener("click", activeClickHandler, { once: true });
};

export const handleDeselectNext = (element: Element | null) => {
  if (element && activeClickHandler) {
    element.removeEventListener("click", activeClickHandler);
  }
  activeClickHandler = null;
};

const handleHighlightClose = (
  element: Element | null,
  opts: { driver?: { destroy?: () => void } },
) => {
  if (!element) return;

  activeClickHandler = () => {
    opts.driver?.destroy?.();
  };

  element.addEventListener("click", activeClickHandler, { once: true });
};

export const clickToNextStepHandlers = {
  onHighlighted: (element: any, _step: any, opts: any) =>
    handleHighlightNext(element, opts),
  onDeselected: (element: any) => handleDeselectNext(element),
};

export const clickToCloseStepHandlers = {
  onHighlighted: (element: any, _step: any, opts: any) =>
    handleHighlightClose(element, opts),
  onDeselected: (element: any) => handleDeselectNext(element),
};
